// extracted by mini-css-extract-plugin
module.exports = {"container":"RetailerGuard_container__1a75H","content":"RetailerGuard_content__1pI7o","image":"RetailerGuard_image__2YJ-9"};